import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = {
  class: "card-title",
  style: {"display":"table-cell","width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = {
  key: 0,
  class: "card-title"
}

import {onMounted, reactive, ref, watch} from "vue";
import ApiService from "@/core/services/ApiService";
import { useRoute } from "vue-router";
import { parseTime } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  weeklyEnable: {type: Boolean, default: true},  //是否展示周期筛选项
  selectionRecommendEnable: {type: Boolean, default: false},  //是否展示周期筛选项
},
  emits: ['searchAction'],
  setup(__props, { emit }) {

const props = __props



const route = useRoute();

const filters = reactive({
  category: [] as string[],  // 类目
  params: {}, //筛选项参数，格式field: value
  selection_id: '',  //输入选品方案ID
  recommend_id: '',  //输入推荐方案ID
  black_id: '',  //输入黑名单方案ID
  weight_id: '',  //输入权重方案ID
  goods_id: '',  //输入商品ID
  weekly: '',  //周期，总共就8周
});
const config = reactive({
  config: {} as any,  //模块配置，包含后台配置筛选项，区域area，事业部bu，商品销售类型goods_sale_type，商品分层goods_type，建议动作actions
  category: [] as any[],  //站点栏目类目配置
  dimension: [] as any[],  //筛选项及选项值
  selection_enabled: false, //是否具有选品模块权限
  recommend_enabled: false, //是否具有推荐模块权限
  weekly: [] as any[], //周期
});
// 筛选项控制
const disabled = reactive({
  selection_id: false,
  recommend_id: false,
  black_id: false,
  weight_id: false,
});

onMounted(() => {
  ApiService.get('report/product/config').then(({data}) => {
    let _categoryTree = (category) => {
      let tree: Array<any> = []
      for (let c of category) {
        let t = {
          label: c.category_name,
          value: c.category_name,
        }
        if (c.children && c.children.length > 0) {
          t['children'] = _categoryTree(c.children)
        }
        tree.push(t)
      }
      return tree
    }
    config.config = data.config;
    let categoryTree: Array<any>  = _categoryTree(data.category);
    config.category = [...categoryTree];
    for (let d of data.dimension) {
      if (d.cat_id === 2) {  //载入商品分析筛选项
        config.dimension.push(d);
        filters['params'][d.dimension_field] = '';
      }
    }
    config.selection_enabled = data.selection_enabled;
    config.recommend_enabled = data.recommend_enabled;
    initQuery();
    searchAction();
  });


});

// 处理页面参数
const initQuery = () => {
  if (props.weeklyEnable) {
    let date = new Date();
    date.setDate(date.getDate() - date.getDay() + 1); //定位到周一
    if (new Date().getDay() == 0) { // 处理周日
      date.setDate(date.getDate() - 7);
    }
    for (let i = 0; i < 8; i++) {
      date.setDate(date.getDate() - 1);
      let v = parseTime(date, "{y}{m}{d}");
      date.setDate(date.getDate() - 6);
      v = parseTime(date, "{y}{m}{d}") + '_' + v;
      config.weekly.push(v);
    }
    // 周一中午前数据未更新，默认选择第二项
    filters.weekly = (new Date().getDay() == 1 && new Date().getHours() < 12) ? config.weekly[1] : config.weekly[0];
  }

  if (props.selectionRecommendEnable) {
    let params = route.query;
    if (params['params'] != undefined) params['params'] = JSON.parse(params['params'] as string);
    for (let p in filters) {
      if (params[p] != undefined) {
        if (p === 'params') {
          for (let f in filters['params']) {
            if (params['params'] && params['params'][f] != undefined) {
              filters['params'][f] = params['params'][f];
            }
          }
        } else if (p === 'category') {
          filters['category'] = params['category'] as string[]
        } else {
          filters[p] = params[p];
        }
      }
    }
  }
}

// 搜索动作
const searchAction = () => {
  emit('searchAction', filters);
}
// 选品ID，推荐方案ID，黑名单ID，权重ID输入项的输入动作
const inputAction = (item) => {
  if (filters[item] === '') {
    disabled.selection_id = false;
    disabled.recommend_id = false;
    disabled.black_id = false;
    disabled.weight_id = false;
  } else {
    disabled.selection_id = true;
    disabled.recommend_id = true;
    disabled.black_id = true;
    disabled.weight_id = true;
    disabled[item] = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_alert, {
        title: "友情提醒：报表数据一般情况下每周一中午更新！",
        type: "info",
        closable: false,
        style: {"margin-top":"5px","padding":"0","line-height":"24px"}
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_cascader, {
          modelValue: _unref(filters).category,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).category) = $event)),
          options: _unref(config).category,
          props: { checkStrictly: true, emitPath: true, expandTrigger: 'hover' },
          placeholder: "商品类目",
          size: "small",
          "collapse-tags": "",
          clearable: "",
          style: {"width":"100px","margin-bottom":"5px"}
        }, null, 8, ["modelValue", "options"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).dimension, (d) => {
          return (_openBlock(), _createBlock(_component_el_select, {
            modelValue: _unref(filters).params[d.dimension_field],
            "onUpdate:modelValue": ($event: any) => ((_unref(filters).params[d.dimension_field]) = $event),
            key: d.dimension_id,
            size: "small",
            placeholder: d.dimension_name,
            clearable: "",
            style: {"width":"100px","margin-left":"5px","margin-bottom":"5px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.items, (v) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: v,
                  label: v,
                  value: v
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
        }), 128)),
        (props.weeklyEnable)
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: _unref(filters).weekly,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).weekly) = $event)),
              size: "small",
              placeholder: "周期",
              style: {"width":"180px","margin-left":"5px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).weekly, (v, k) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: k,
                    label: v,
                    value: v
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          icon: "el-icon-search",
          size: "small",
          onClick: searchAction,
          style: {"float":"right"}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (__props.selectionRecommendEnable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(config).selection_enabled)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: _unref(filters).selection_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).selection_id) = $event)),
                  disabled: _unref(disabled).selection_id,
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (inputAction('selection_id'))),
                  placeholder: "选品方案ID",
                  size: "small",
                  style: {"width":"120px"}
                }, null, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true),
            (_unref(config).recommend_enabled)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  modelValue: _unref(filters).recommend_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).recommend_id) = $event)),
                  disabled: _unref(disabled).recommend_id,
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (inputAction('recommend_id'))),
                  placeholder: "推广方案ID",
                  size: "small",
                  style: {"width":"120px","margin-left":"5px"}
                }, null, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true),
            (_unref(config).recommend_enabled)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 2,
                  modelValue: _unref(filters).black_id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filters).black_id) = $event)),
                  disabled: _unref(disabled).black_id,
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (inputAction('black_id'))),
                  placeholder: "黑名单方案ID",
                  size: "small",
                  style: {"width":"120px","margin-left":"5px"}
                }, null, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true),
            (_unref(config).recommend_enabled)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 3,
                  modelValue: _unref(filters).weight_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(filters).weight_id) = $event)),
                  disabled: _unref(disabled).weight_id,
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (inputAction('weight_id'))),
                  placeholder: "权重方案ID",
                  size: "small",
                  style: {"width":"120px","margin-left":"5px"}
                }, null, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_input, {
              modelValue: _unref(filters).goods_id,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(filters).goods_id) = $event)),
              placeholder: "商品ID，多个ID用,分隔",
              size: "small",
              style: {"width":"250px","margin-left":"5px"}
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})